import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  hasAppPermission,
  hasAnyAppPermission,
  hasAllAppPermissions,
  getPrimaryCompanyUser,
  shouldApplyAppRbacMenu,
  P,
} from '../constants/rbac';

/**
 * Hook for app RBAC checks against /auth/me primary company membership.
 * Legacy (non-app RBAC) users get allow-all.
 */
export function useAppPermission() {
  const meDetails = useSelector((state) => state.auth?.meDetails);
  const companyUser = useMemo(() => getPrimaryCompanyUser(meDetails), [meDetails]);
  const isAppRbac = shouldApplyAppRbacMenu(companyUser);

  return useMemo(
    () => ({
      meDetails,
      companyUser,
      isAppRbac,
      permissionCodes: companyUser?.permission_codes || [],
      can: (code) => hasAppPermission(meDetails, code),
      canAny: (codes) => hasAnyAppPermission(meDetails, codes),
      canAll: (codes) => hasAllAppPermissions(meDetails, codes),
      P,
    }),
    [meDetails, companyUser, isAppRbac]
  );
}

export default useAppPermission;
